import $ from '@ali/tarzan-zepto';
import tpl from './tpl.html';
import BaseUI from '../../../component/baseui/index';
import util from '../../../lib/util.js';
import log from '../../../lib//log.js';
import { getTranslation } from '../../../utils';

import './style.scss';

const pressEvent = util.isPC() ? 'click' : 'tap';

export default function evaluate(data) {
  const param = {
    name: 'evaluate',
    side: 'center',
    mid: data.mid,
    content: tpl.render(data),
  };
  const $node = $(BaseUI.msg(param));
  const $text = $node.find('[data-evaluate="text"]');
  const goodAction = JSON.stringify(data.button[0].action);
  const badAction = JSON.stringify(data.button[1].action);
  const evaluatedClass = 'evaluated';
  const activeModifier = '-active';
  const disabledModifier = '-disabled';
  const valueData = 'evaluate-value';
  const goodValue = 'good';
  const badValue = 'bad';

  $node.find('[data-evaluate="button"]').on(pressEvent, (ev) => {
    const $el = $(ev.target);
    const isGoodValue = $el.data(valueData) === goodValue;

    if ($node.hasClass(evaluatedClass)) return;
    $text.text(this.util.lang.get('FEEDBACK:THANKS'));
    $el.addClass(activeModifier)
        .siblings().addClass(disabledModifier);
    $node.addClass(evaluatedClass);

    if (data.isKnowledge) {
      if (isGoodValue) {
        this.appendMessage({
          type: 'robot',
          body: {
            text: this.util.lang.get('KNOWLEDGE:GOOD'),
          },
        });
      } else {
        this.appendMessage({
          type: 'robot',
          body: {
            text: this.util.lang.get('KNOWLEDGE:BAD'),
          },
        });

        const liveAgent = getTranslation('csc.shortcut.liveagent');
        let shortcuts = [{ code: 'liveAgent', icon: 'service', text: liveAgent, type: 'text', title: liveAgent, content: liveAgent }];

        if (!this.shortcuts.agentHidden) {
          shortcuts = shortcuts.concat(this.essentials.config.config.shortcuts || []);
        } else {
          shortcuts = this.essentials.config.config.shortcuts || [];
        }
        if (shortcuts.length) {
          this.appendMessage({
            type: 'dynamic_shortcuts',
            body: {
              isAdd: false,
              shortcuts,
            },
          });
        }

        this.liveAgent = {
          entry: 'thumbDown',
        };

        log.liveAgent({ entry: 'thumbDown', type: 'show', chatUuid: this.chatUuid, intent: '' });
        setTimeout(() => {
          this.view.body.scrollToBottom();
        }, 50);
      }
    } else if (isGoodValue) {
      this.view.footer.submit({ q: goodValue, ext: { botJson: goodAction } }, 'text', false, true);
    } else {
      this.view.footer.submit({ q: badValue, ext: { botJson: badAction } }, 'text', false, true);
    }
    this.model.robotRate({
      feedback: isGoodValue ? '1' : '2',
      chatUuid: data.chatUuid,
    });
  });

  return {
    // 插件返回的结果
    body: $node,
    // 插件调用ready后的回调
    callback: () => {
      //
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/extension/evaluate/index.js